import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import { IAttachment } from "../../model/Attachment";
import { TAttachmentTypePresentationModel } from "../../../organisations/presenter/model/AttachmentTypePresentationModel";

export interface TAttachmentPresentationModel extends IAttachment {
  attachmentTypeName: string;
  attachmentType: TAttachmentTypePresentationModel;
  contentType: IGenericCodebookItem;
  identificationCode: string;
  file?: any;
}

const AttachmentPresentationModel = (
  data: IAttachment,
  attachmentType?: TAttachmentTypePresentationModel,
  file?: any,
  code?: string
) => {
  const attachmentTypeName = attachmentType?.name;
  const contentType = attachmentType?.contentType;
  const handler: ProxyHandler<IAttachment> = {
    get: function (target, prop, receiver) {
      switch (prop) {
        case "attachmentTypeName":
          return attachmentTypeName;
        case "attachmentType":
          return attachmentType;
        case "contentType":
          return contentType;
        case "identificationCode":
          return code;
        case "file":
          return file;
        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "attachmentTypeName":
        case "attachmentType":
        case "contentType":
        case "identificationCode":
        case "file":
          return true;
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<IAttachment, TAttachmentPresentationModel>(data, handler);
};

export default AttachmentPresentationModel;
